import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils'
import { Table, Typography, message, Spin, Modal, Button, Popconfirm } from 'antd';
import {
  HighlightOutlined,
  CheckOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined
} from '@ant-design/icons';
export default {
  getConferences: async function (setFuncMap, conferencesMode) {
    try {
      setFuncMap.setIsTableLoading(true)
      const res = await this.getConferencesAction(1, 100, conferencesMode)
      let conferencesCom = res.data.datas.map((data, k) => {
        return {
          isUpdateName: false,
          isNotAvailableEnter: false,
          conferencesMode,
          ...data
        }
      })
      setFuncMap.setConferences(conferencesCom)
      setFuncMap.setIsTableLoading(false)
      setFuncMap.setIsPageLoading(false)
    } catch (error) {
      setFuncMap.setIsTableLoading(false)
      // message.error(error.response.data)
    }
  },
  getConferencesAction: (page, size, conferencesMode) => {
    return axios({
      method: 'GET',
      url: `/conferences?page=${page}&size=${size}&mode=${conferencesMode}`,
      headers: {
        "role": "topUser"
      }
    })
  },
  updateReferenceNameByUid: async function (payload, setFuncMap) {
    const { waitUpdateData, conferences } = payload
    let instance = JSON.parse(JSON.stringify(conferences))
    let conf = instance.find(conference => {
      return conference.uid === waitUpdateData.uid
    })
    try {
      setFuncMap.setIsModalOpen(false)
      conf.isUpdateName = true
      conf.isNotAvailableEnter = true
      setFuncMap.setConferences(instance)
      await this.updateConferenceAction(waitUpdateData)
      let cloneInstance = toolUtils.clone(instance)
      let cloneConf = cloneInstance.find(conference => {
        return conference.uid === waitUpdateData.uid
      })
      cloneConf.name = waitUpdateData.after
      cloneConf.isUpdateName = false
      cloneConf.isNotAvailableEnter = false
      setFuncMap.setConferences(cloneInstance)
    }
    catch (e) {

    }
  },
  updateConferenceAction: (waitUpdateData) => {
    return axios.put(`/conference/${waitUpdateData.uid}`, {
      "name": waitUpdateData.after
    }, {
      headers: {
        "role": "topUser"
      }
    })
  },
  copyConferenceByUid: async function (conferenceSetting, setFuncMap, conferencesMode) {
    try {
      setFuncMap.setConferenceSetting({
        ...conferenceSetting,
        copyIsLoading: true
      })
      await this.copyConferenceByUidAction(conferenceSetting.uid)
      setFuncMap.setConferenceSetting({
        ...conferenceSetting,
        copyIsLoading: false
      })
      message.open({
        type: 'success',
        content: "複製成功",
        duration: 2,
      })
      this.getConferences(setFuncMap, conferencesMode)
    }
    catch (e) {
      setFuncMap.setConferenceSetting({
        ...conferenceSetting,
        copyIsLoading: false
      })
      message.open({
        type: 'error',
        content: "複製失敗",
        duration: 2,
      })
    }
  },
  copyConferenceByUidAction: (uid) => {
    return axios.post(`/conference/${uid}/copy`, {
    }, {
      headers: {
        "role": "topUser"
      }
    })
  },
  archiveConferenceByUid: async function (conferenceSetting, setFuncMap, conferencesMode) {
    try {
      setFuncMap.setConferenceSetting({
        ...conferenceSetting,
        archiveIsLoading: true
      })
      await this.archiveConferenceByUidAction(conferenceSetting.uid)
      setFuncMap.setConferenceSetting({
        isOpen: false
      })
      message.open({
        type: 'success',
        content: "封存成功",
        duration: 2,
      })
      this.getConferences(setFuncMap, conferencesMode)
    }
    catch (e) {
      setFuncMap.setConferenceSetting({
        ...conferenceSetting,
        archiveIsLoading: false
      })
      message.open({
        type: 'error',
        content: "封存失敗",
        duration: 2,
      })
    }
  },
  archiveConferenceByUidAction: (uid) => {
    return axios.delete(`/conference/${uid}`, {
      headers: {
        "role": "topUser"
      }
    }, {})
  },
  cancelArchiveConferenceByUid: async function (uid, setFuncMap, conferencesMode) {
    try {
      await this.cancelArchiveConferenceByUidAction(uid)
      message.open({
        type: 'success',
        content: "取消封存成功",
        duration: 2,
      })
      this.getConferences(setFuncMap, conferencesMode)
    }
    catch (e) {
      message.open({
        type: 'error',
        content: "取消封存失敗",
        duration: 2,
      })
    }
  },
  cancelArchiveConferenceByUidAction: (uid) => {
    return axios.put(`/conference/${uid}/cancelarchvie`, {}, {
      headers: {
        "role": "topUser"
      }
    }, {})
  },
  updateConferenceIsActiveByUid: async function (uid, isActive, setFuncMap, conferencesMode) {
    try {
      setFuncMap.setIsSaveLoading(true)
      await this.updateConferenceIsActiveByUidAction(uid, isActive)
      message.open({
        type: 'success',
        content: "儲存成功",
        duration: 2,
      })
      setFuncMap.setIsSaveLoading(false)
      setFuncMap.setConferenceSetting({
        isOpen: false
      })
      this.getConferences(setFuncMap, conferencesMode)
    }
    catch (e) {
      setFuncMap.setIsSaveLoading(false)
      message.open({
        type: 'error',
        content: "儲存失敗",
        duration: 2,
      })
    }
  },
  updateConferenceIsActiveByUidAction: (uid, isActive) => {
    return axios.post(`/conference/${uid}/is_active`, { isActive }, {
      headers: {
        "role": "topUser"
      }
    }, {})
  },
  generateConferenceColumns: function (params) {
    const { Text } = Typography
    const { conferences, setFuncMap, location, navigate, getReferenceByUid } = params
    const NameCell = function (props) {
      let render = props.render
      return <Spin spinning={render.isUpdateName}><Text editable={{
        icon: <HighlightOutlined />,
        tooltip: 'click to edit text',
        onChange: (text) => {
          let conf = getReferenceByUid(render.uid, conferences)
          if (text !== conf.name) {
            setFuncMap.setWaitUpdateData({
              uid: conf.uid,
              before: conf.name,
              after: text
            })
            setFuncMap.setIsModalOpen(true)
          }
        },
        enterIcon: <CheckOutlined />,
      }}>
        {render.name}
      </Text></Spin>
    }
    return [
      {
        title: '研討會名稱',
        dataIndex: 'name',
        key: 'name',
        width: 500,
        render: (_, render) => {
          return <NameCell render={render} />
        },
      },
      {
        title: '狀態',
        dataIndex: 'isActive',
        key: 'isActive',
        align: 'center',
        render: (val) => {
          return <>{val === 0 ? <PlayCircleOutlined className="inactive" fill="#000000" /> : <PlayCircleOutlined className="active" />}</>
        }
      },
      {
        title: '最後更新時間',
        dataIndex: 'lastUpdateAt',
        key: 'lastUpdateAt',
      },
      {
        title: '建立時間',
        dataIndex: 'createAt',
        key: 'createAt',
      },
      {
        title: ' ',
        dataIndex: 'uid',
        key: 'uid',
        render: (_, record) => {
          return <>{record.conferencesMode == "conferences" ? <div className="btns">
            <Button className="edit" onClick={() => {
            window.open(`${window.location.protocol}//${window.location.host}/conference/${record.uid}`)
          }} disabled={record.isNotAvailableEnter}>預覽</Button>
          <Button className="edit" onClick={() => {
            navigate(`${location.pathname}/${record.uid}`)
          }} disabled={record.isNotAvailableEnter}>進入</Button>
            <Button className="setting-conference" onClick={() => {
              setFuncMap.setConferenceSetting({
                isOpen: true,
                title: record.name,
                uid: record.uid,
                isActive: record.isActive
              })
            }}>設定</Button>
          </div> :
            <div className="btns"><Popconfirm
              placement="left"
              title={`確認要解除 ${record.name} 封存?`}
              onConfirm={() => { this.cancelArchiveConferenceByUid(record.uid, setFuncMap, record.conferencesMode) }}
              okText="Yes"
              cancelText="No"
            ><Button className="cancel-archive-btn">解除封存</Button>
            </Popconfirm></div>}</>
        }
      }]
  },
  getReferenceByUid: (uid, conferences) => {
    let instance = JSON.parse(JSON.stringify(conferences))
    return instance.find(conference => {
      return conference.uid === uid
    })
  }
}